import UseContext from "../../../hooks/useContext";
import ModalLogout from "./data/modalLogout/ModalLogout";
import ModalAddTeam from "./data/modalTeam/ModalAddTeam";
import ModalEditWorkerPhone from "./data/modalEditWorkerPhone/ModalEditWorkerPhone";
import ModalModifyTeam from "./data/modalTeam/ModalModifyTeam";
import ModalDeleteTeam from "./data/modalTeam/ModalDeleteTeam";
import ModalEditWorkerToken from "./data/modalEditWorkerToken/ModalEditWorkerToken";
import ModalLogTimeSheet from "./data/modalLogTimeSheet/ModalLogTimeSheet";

const dataModal = new Map();
dataModal.set("log_d_logout", <ModalLogout />);
dataModal.set("add_team", <ModalAddTeam />);
dataModal.set("modify_team", <ModalModifyTeam />);
dataModal.set("delete_team", <ModalDeleteTeam />);
dataModal.set("edit_worker_phone", <ModalEditWorkerPhone />);
dataModal.set("edit_worker_token", <ModalEditWorkerToken />);
dataModal.set("log_time_sheet", <ModalLogTimeSheet />);

const Datamodal = () => {
  const { modalType } = UseContext();
  return <>{dataModal.get(modalType)}</>;
};

export default Datamodal;
